/**
 * File Viewer (piece 4): the screen a shared-file link's permission renders
 * into. Phase 1 renders the permission the link hands it and never decides
 * one; the toolbar is determined by that permission alone, so a View link
 * carries no Download control at all; print is blocked through the same check;
 * View-only draws the watermark.
 */
export type LinkPermission = 'View' | 'Download';

export interface ViewerToolbar {
  download: boolean;
  print: boolean;
  watermark: boolean;
}

export function toolbarFor(permission: LinkPermission): ViewerToolbar {
  const full = permission === 'Download';
  return { download: full, print: full, watermark: !full };
}

/** The one print gate: the same permission that removes the Download control intercepts the browser's print. */
export function printAllowed(permission: LinkPermission): boolean {
  return toolbarFor(permission).print;
}
